import { Search, Users } from 'lucide-react';
import { motion } from 'framer-motion';

interface HeaderProps {
  activeTab: 'search' | 'matches';
  onTabChange: (tab: 'search' | 'matches') => void;
}

export default function Header({ activeTab, onTabChange }: HeaderProps) {
  return (
    <header className="w-full max-w-4xl mx-auto px-4 py-8">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-2">
          <span className="text-purple-600">✨</span>
          Find Your Name Match!
        </h1>
        <p className="text-gray-600">
          Discover the meaning of Nepali names and find out who likes your name the most!
        </p>
      </div>

      <div className="flex gap-4 justify-center mb-8">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onTabChange('search')}
          className={`flex items-center gap-2 px-6 py-3 rounded-full ${
            activeTab === 'search'
              ? 'bg-purple-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          } shadow-sm transition-colors`}
        >
          <Search size={20} />
          Name Meaning Search
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onTabChange('matches')}
          className={`flex items-center gap-2 px-6 py-3 rounded-full ${
            activeTab === 'matches'
              ? 'bg-purple-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          } shadow-sm transition-colors`}
        >
          <Users size={20} />
          Who Likes Your Name?
        </motion.button>
      </div>
    </header>
  );
}